import React from "react";
import { motion } from "framer-motion";
import "./HowItWorks.css";

export const HowItWorks = ({ onZodiacSelect }) => {
  const steps = [
    {
      number: 1,
      title: "Enter Your DOB",
      description: "Tell us when you were born and let the universe speak",
      icon: "📅",
    },
    {
      number: 2,
      title: "Get Roasted",
      description: "Our AI unleashes the brutal cosmic truth about your destiny",
      icon: "🔥",
    },
    {
      number: 3,
      title: "Share with Friends",
      description: "Laugh, share, and let them know what the stars really think",
      icon: "🚀",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          How It Works
        </motion.h2>

        <motion.div
          className="steps-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              className="step"
              variants={itemVariants}
              whileHover={{ y: -10 }}
            >
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">
                <span className="step-number">{step.number}</span>
                {step.title}
              </h3>
              <p className="step-description">{step.description}</p>

              {index < steps.length - 1 && (
                <div className="step-arrow">→</div>
              )}
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          className="how-it-works-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          No login needed. No data stored. No BS. Just pure cosmic roasting. ⚡
        </motion.p>
      </div>
    </section>
  );
};
